module.exports = "/images/tag_5134c0.png";